<template>
    <div>
        <!--Header Components-->

        <base-header class="pb-4" type="">

        <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
                <!-- <h6 class="h2 d-inline-block mb-0">{{$route.params.id}}</h6> -->
                <!-- <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb/>
                </nav> -->
                </b-col>
        </b-row>
        </base-header>
        <div>
            <loading :active="loadingCounter > 0" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="false" 
              :is-full-page="true">
            </loading>
        </div>
        <b-container fluid class="mt--6">
            <b-row class="mb-4">
                <!-- <template v-if="picklist.status == 'PENDING'">
                    <fab
                    :position="position"
                    :bg-color="bgColor"
                    :actions="fabActions2"
                    @generate="clickOnStartPickProcess"
                    @back="clickOnBack"
                    v-if="loadingCounter == 0"
                    ></fab>
                </template> -->
                <b-col md="12" class="mt-2 ml-3">
                    <b>{{$route.params.id}}</b>
                </b-col>
                <b-col md="12">
                    <b-tabs pills card>
                        <b-tab v-for="classification in picklist.classifications" :key="classification.id" :title="classification.id + ' (' + classification.waybills_remaining  + ' / ' + ((classification.waybills_remaining * 1) + (classification.waybills_completed * 1))+ ')'" @click="onClickClassification(classification)">
                        </b-tab>
                    </b-tabs>
                </b-col>

                <b-col cols="12" class="mt--4">
                    <b-form-input id="gtin" ref="gtin" v-model="gtin" autofocus v-on:keyup.enter="packScanGTIN" class="mb-5"></b-form-input>

                    <!-- <base-input v-model="gtin" v-on:keyup.enter="packScanGTIN">
                    </base-input> -->
                </b-col>

                <b-col cols="12" class="mt--4">
                    <b-card v-if="waybill != null">
                        <b-row>
                            <b-col cols="12">
                                <b-card>
                                    <!-- 'https://cdn.unityerp.com/dbase/sales/hktvm/waybills/' + this.waybill.waybill_code + '.pdf' -->
                                    <b-row><b-col @click="printLast()" class="text-center" cols="12"><h1 :style="waybill_color">WAYBILL {{waybill.waybill_code}}</h1></b-col></b-row>
                                    <b-row>
                                        <b-col cols="6">
                                            <div class="mt-2 text-center mb-4"><h2>Outstanding</h2></div>
                                            <b-card-group v-for="(item,index) in waybill.items_outstanding" :key="index">
                                                <b-card no-body class="overflow-hidden mb-4" @click = "clickOnOutstandingCard(item)">
                                                    <b-row no-gutters>
                                                        <b-col md="6">
                                                            <b-card-img :src="item.image" alt="Image" class="rounded-0"></b-card-img>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-card-body :title="item.product_name" style="font-size:xx-large">
                                                                <b-card-text>
                                                                    <div class="text-center"><h1 style="font-size:xx-large">{{item.qty}} <span style="color:red">{{ item.multiplier }}</span></h1></div>
                                                                    <div class="text-center" v-if="item.gtin != null"><VueBarcode :value="item.gtin" :options="{ lineColor: '#0275d8', text: 'Scan'}"></VueBarcode></div>
                                                                    <div class="text-center" v-if="item.gtin != null" style="font-size:larger;font-weight: bolder;"><b>{{item.brand}}</b></div>
                                                                    <div class="text-center mt--2" v-if="item.gtin != null" style="font-size:large;font-weight: bolder;"><b>{{item.product_code}}</b></div>
                                                                </b-card-text>
                                                            </b-card-body>
                                                        </b-col>
                                                    </b-row>
                                                </b-card>
                                            </b-card-group>
                                        </b-col>
                                        <b-col cols="6">
                                            <div class="mt-2 text-center mb-4"><h2>Packed</h2></div>
                                            <b-card-group v-for="(item,index) in waybill.items_packed" :key="index">
                                                <b-card no-body class="overflow-hidden mb-4">
                                                    <b-row no-gutters>
                                                        <b-col md="6">
                                                            <b-card-img :src="item.image" alt="Image" class="rounded-0"></b-card-img>
                                                        </b-col>
                                                        <b-col md="6">
                                                            <b-card-body :title="item.product_name">
                                                                <b-card-text>
                                                                    <div class="text-center"><h1 style="font-size:xx-large">{{item.qty}}</h1></div>
                                                                    <div class="text-center" v-if="item.gtin != null"><VueBarcode :value="item.gtin" :options="{ lineColor: '#0275d8', text: 'Scan'}"></VueBarcode></div>
                                                                    <div class="text-center" v-if="item.gtin != null" style="font-size:larger;font-weight: bolder;"><b>{{item.brand}}</b></div>
                                                                    <div class="text-center mt--2" v-if="item.gtin != null" style="font-size:large;font-weight: bolder;"><b>{{item.product_code}}</b></div>
                                                                </b-card-text>
                                                            </b-card-body>
                                                        </b-col>
                                                    </b-row>
                                                </b-card>
                                            </b-card-group>

                                            <b-card-group v-if="0" deck v-for="(item,index) in waybill.items_packed" :key="index">
                                                <b-card 
                                                style="text-decoration:none;
                                                color:#000;
                                                background:#ffcf;
                                                display:block;
                                                height:10em;
                                                width:10em;
                                                padding:0em;
                                                box-shadow: 5px 5px 7px rgba(33,33,33,.2);"
                                                class="mb-3 text-center" :title="item.product_name"><b-card-text class="mt--2 mb--1"><h3>{{item.qty}}</h3><b>{{item.gtin}}</b></b-card-text></b-card>
                                            </b-card-group>                                        
                                        </b-col>
                                </b-row>
                            </b-card>
                            </b-col>
                            
                            <b-col cols="6">


                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
        
        <b-modal centered header-bg-variant="light" header-text-variant="" title="Register GTIN" v-model="modalRegisterGTIN" @ok="registerGTIN()">
            <div>
                <h2>GTIN</h2>
                <b-form-input  id="gtin_entry" ref="gtin_entry" v-model="gtin_new" autofocus></b-form-input>
            </div>
        </b-modal>

        <b-modal centered header-bg-variant="light" header-text-variant="" title="Confirmation" v-model="modalConfirmBatchClose" @ok="confirmCloseBatch()">
            Proceed to close batch?
        </b-modal>

        <b-modal  hide-backdrop content-class="shadow" centered title="Error" v-model="modalError" ok-only>
            <p class="my-2">{{modalErrorMessage}}</p>
        </b-modal>

    </div>
    
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
th.VueTables__sortable {
    color:rgb(255,255,255);
}
td.VueTables__row  {
    color:black
}
</style>
<script>
import * as Printjs from "print-js"
import VueBarcode from 'vue-barcode'
import Vue from 'vue';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import { mapState } from "vuex";
import axios from "axios";
import fab from 'vue-fab'  

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 
import { Select, Option } from 'element-ui'

export default {
    name:'Location-Details',
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
            storage_classifications: state => state.storageclassifications.storage_classifications,
            active_locations: state => state.locations.active_locations,
            location_created: state => state.locations.is_created,
            location_updated: state => state.locations.is_updated,
            location_filter: state => state.locations.filter,
            location_data: state => state.locations.data,
            auth_user:state =>state.auth.auth_user,
        })
    },
    data(){
        return{
            waybill_color:'color:black',
            lastPrintFile:null,
            product:[],
            gtin_new:'',
            modalRegisterGTIN: false,
            locations:[],
            brands:[],
            waybill_code:null,
            modalError:false,
            modalErrorMessage: '',
            waybill:null,
            gtin:'',
            modalConfirmBatchClose:false,
            isPickListBatchClosed: true,
            pdfFile: '',
            pickingColumns:['id','location', 'brand', 'qty', 'product_name', 'qty_open', 'action'],
            // pickingOptions:{groupBy :['location', 'brand']},
            pickingOptions:{perPage:10000, perPageValues:[],stickyHeader:false, stickyHeaderBackground:'#292F4C',hiddenColumns:['id'],filterable:false
            ,texts:{count:"", filter: "", filterPlaceholder: "Quick Lookup",}
            ,editableColumns: ['qty_open']                        
            ,sortIcon: {
            is: "glyphicon-sort",
            base: "glyphicon",
            up: "glyphicon-chevron-up",
            down: "glyphicon-chevron-down"
            },
            sortingAlgorithm(data, column) {
            return data.sort(this.getSortFn(column));
            },
            },

            pickingItems: [],
            selectedClassification: null,
            selectedLocation:null,
            selectedBrand:null,
            picklist:{
                slots:[],
                stats:{},
                classifications:[],
            },
            loadingCounter:0,
            title:"",
            is_edit:false,
            bgColor: '#17BA19',
            position: 'bottom-right',
            fabActions: [
                {
                    name: 'generate',
                    icon: 'local_mall',
                    color: 'orange'
                },
                {
                    name: 'pack',
                    icon: 'local_shipping',
                    color: '#42b0f5'
                }                
            ],
            fabActions2: [
                {
                    name: 'back',
                    icon: 'arrow_back',
                    color: 'red',
                },
                {
                    name: 'top',
                    icon: 'north',
                    color: 'green'
                }                
            ],          
            selectedSlotsCount:0,
            masks: {
            weekdays: 'WWW',
            },
            attributes: [],
        }
    },
    components:{
        VueBarcode,
        flatPicker,
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
        fab,
    },
    async mounted()
    {
        this.retrievePickList(this.$route.params.id)
        this.gtin = localStorage.gtin
    },
    methods:{
        async printLast()
        {
            //this.lastPrintFile = 'https://cdn.unityerp.com/dbase/sales/hktvm/waybills/' + '6293793009' + '.pdf'
            printJS(this.lastPrintFile)
        },
        async onClickDownloadWaybills()
        {
            this.loadingCounter++

            if (1)
            {
                let mode = 'waybills_classification'
                let apiUrl = apiRoutes['DBASE_DOWNLOAD_WAYBILLS']
                let auth_header = authHeader()
                // console.log(authHeader)
                auth_header.responseType = 'blob'

                await axios.post(apiUrl, {picklist_id:this.picklist.id, classification:this.selectedClassification, mode:mode}, auth_header
                ).then((response) => {
                    const url = URL.createObjectURL(new Blob([response.data], auth_header))
                    const link = document.createElement('a')
                    let filename = ''
                    if (mode == 'waybills_classification')
                        filename = this.picklist.code + ' Waybills (' + this.selectedClassification + ').pdf'

                    link.href = url
                    link.setAttribute('download',  filename)
                    document.body.appendChild(link)
                    link.click()
                    location.reload()
                });
            }
            this.loadingCounter--
        },
        scrollTop()
        {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            // document.getElementById('app').scrollIntoView();
        },
        onClickClassification(classification)
        {
            if (this.selectedClassification == classification.id)
            {
                this.onClickDownloadWaybills()
            }
            else
            {
                this.selectedClassification = classification.id
                this.selectedLocation = null
                this.selectedBrand = null
            }
        },
        playSound (sound)
        {
            if(sound) {
                var audio = new Audio(sound);
                audio.play();
            }
        },
        promptError(msg)
        {
            this.playSound('https://cdn.unityerp.com/core/sounds/ding.mp3')
            this.modalErrorMessage = msg
            this.modalError = true
        },
        async clickOnOutstandingCard(card)
        {
            this.gtin = card.gtin
            this.packScanGTIN(card)
        },
        async registerGTIN()
        {
            // console.log(this.product.product_id)
            // alert(this.product.product_id)
            // alert(this.gtin_new)

            if (this.gtin_new != null && this.gtin_new != '')
            {
                let payload = {"code":this.gtin_new,"type":"barcode_upc","tag":"GTIN","product_id":this.product.product_id}
                axios.post(apiRoutes["CREATE_PRODUCT_CODE"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    // this.gtin = this.gtin_new
                    this.gtin = response.data.data.code
                    this.packScanGTIN()
                }
                else
                {
                    alert(response.data.msg)
                } 
                })
                .catch((error) => 
                {
                    this.loadingCounter--
                    if (error.response) 
                    {
                        Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                    } 
                });
            }
            else
            {
                alert('Invalid GTIN')
            }
//            alert(this.)
        },
        async packScanGTIN(card)
        {
            //console.log(this.auth_user)

            if (this.gtin == null)
            {
                this.product = card
                this.modalRegisterGTIN = true
            }
            else if (this.selectedClassification == 'WAYBILLS' && this.waybill_code == null)
            {
                this.loadingCounter++
                
                localStorage.gtin = this.gtin
                let payload = {picklist_id: this.picklist.id, waybill_code: this.gtin, gtin:null, classification:this.selectedClassification}
                axios.post(apiRoutes["WAYBILL_AUTO_GTIN_SCAN"], payload, authHeader()).then((response) => {
                    if (response.data.code == 1) 
                    {
                        if (response.data.msg == '')
                            this.promptError('Waybill not found')
                        else
                        {
                            this.waybill = response.data.data
                            if (this.waybill.s1 == 'A')
                                this.waybill_color = 'color:red'
                            else if (this.waybill.s1 == 'B')
                                this.waybill_color = 'color:green'
                            else if (this.waybill.s1 == 'C')
                                this.waybill_color = 'color:blue'
                            else if (this.waybill.s1 == 'D')
                                this.waybill_color = 'color:purple'                            
                            // if (!this.waybill.gtin_added)
                            //     this.playSound('https://cdn.unityerp.com/core/sounds/ding.mp3')
                            // else
                            //     this.playSound('https://cdn.unityerp.com/core/sounds/pop.mp3')

                            this.waybill_code = this.waybill.waybill_code
                            if (this.waybill.items_outstanding.length == 0 || this.auth_user.handle == 'brian')
                            {
                                this.setPrinted(this.waybill_code)
                                this.retrievePickList(this.$route.params.id)
                                this.playSound('https://cdn.unityerp.com/core/sounds/nice.mp3')
                                this.lastPrintFile = 'https://cdn.unityerp.com/dbase/sales/hktvm/waybills/' + this.waybill.waybill_code + '.pdf'
                                this.lastPrintFile = this.waybill.waybill_url
                                    
                                if (this.selectedClassification != 'WAYBILLS' || this.auth_user.handle == 'brian')
                                {
                                    printJS(this.lastPrintFile)
                                    this.gtin = null
                                    this.waybill_code = null
                                }
                            }
                        }
                    } 
                })
                .catch((error) => 
                {
                    if (error.response) 
                    {
                        Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                    } 
                });
                this.loadingCounter--
            }
            else
            {
                this.loadingCounter++

                localStorage.gtin = this.gtin
                let payload = {picklist_id: this.picklist.id, waybill_code: this.waybill_code, gtin:this.gtin, classification:this.selectedClassification}
                axios.post(apiRoutes["WAYBILL_AUTO_GTIN_SCAN"], payload, authHeader()).then((response) => {
                    if (response.data.code == 1) 
                    {
                        if (response.data.msg == '')
                            this.promptError('GTIN not found')
                        else
                        {
                            this.waybill = response.data.data

                            if (this.waybill.s1 == 'A')
                                this.waybill_color = 'color:red'
                            else if (this.waybill.s1 == 'B')
                                this.waybill_color = 'color:green'
                            else if (this.waybill.s1 == 'C')
                                this.waybill_color = 'color:blue'
                            else if (this.waybill.s1 == 'D')
                                this.waybill_color = 'color:purple'

                            if (!this.waybill.gtin_added)
                                this.playSound('https://cdn.unityerp.com/core/sounds/ding.mp3')
                            else
                                this.playSound('https://cdn.unityerp.com/core/sounds/pop.mp3')

                            this.waybill_code = this.waybill.waybill_code
                            
                            if (this.waybill.items_outstanding.length == 0)
                            {
                                this.retrievePickList(this.$route.params.id)
                                this.playSound('https://cdn.unityerp.com/core/sounds/nice.mp3')
                                this.lastPrintFile = 'https://cdn.unityerp.com/dbase/sales/hktvm/waybills/' + this.waybill.waybill_code + '.pdf'
                                this.lastPrintFile = this.waybill.waybill_url
                                if (this.selectedClassification != 'WAYBILLS')
                                {
                                    printJS(this.lastPrintFile)
                                }
                                this.waybill_code = null
                            }
                        }
                    } 
                })
                .catch((error) => 
                {
                    if (error.response) 
                    {
                        Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                    } 
                });
                this.gtin = ''
                this.gtin_new = ''

                this.loadingCounter--
            }

            this.$refs.gtin.focus();
        },
        setPrinted(waybill)
        {
            let payload = {waybill: waybill}
            axios.post(apiRoutes["WAYBILL_SET_PRINTED"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {

                } 
            })
            .catch((error) => 
            {
                if (error.response) 
                {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                } 
            });
        },
        confirmCloseBatch()
        {
            let payload = {picklist_id: this.picklist.id, classification: this.selectedClassification}
            axios.post(apiRoutes["PICKLIST_CLOSE_BATCH"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.isPickListBatchClosed = true    
                } 
            })
            .catch((error) => 
            {
                if (error.response) 
                {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                } 
            });
        },
        closeBatch()
        {
            this.modalConfirmBatchClose = true
        },
        clickOnPickItem(row)
        {
            for (let x = 0; x < this.pickingItems.length; x++) {
                if (this.pickingItems[x].id == row.id)
                {
                    let payload = {picklist_item_id: row.id, qty: row.qty_open}
                    axios.post(apiRoutes["PICKLIST_UPDATE_ITEM_QTY_INCREMENTAL"], payload, authHeader()).then((response) => {
                        if (response.data.code == 1) 
                        {
                            this.$delete(this.pickingItems, x)
                        } 
                    })
                    .catch((error) => 
                    {
                        if (error.response) 
                        {
                            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                        } 
                    });
                    break
                }
            }            
        },
        async clickOnGenerate()
        {
            if (this.picklist.slots.length > 0)
            {
                this.loadingCounter++

                this.picklist.slots = this.picklist.slots
                let payload = this.picklist;
                axios.post(apiRoutes["PICKLIST_GENERATE_FROM_WAYBILL_SLOTS"], payload, authHeader()).then((response) => {
                    if (response.data.code == 1) 
                    {
                        this.retrieveSalesFulfillmentCalendar();
                        this.func = 'calendar';
                    } 
                })
                .catch((error) => 
                {
                    if (error.response) 
                    {
                        Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                    } 
                });
                this.loadingCounter--        
            }
            else
            {
                alert('Empty pickup slot')
            }
        },
        async retrievePickList(picklist_code)
        {
            this.loadingCounter++
            let payload = {code: picklist_code, no_items:'', skip_waybills_download: 1}
            axios.post(apiRoutes["PICKLIST_RETRIEVE"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    this.picklist = response.data.data
                    if (this.selectedClassification == null && this.picklist.classifications.length > 0)
                    {
                        //console.log(this.picklist.classifications)
                        this.selectedClassification = this.picklist.classifications[0].id
                    }
                } 
            })
            .catch((error) => 
            {
                if (error.response) 
                {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                } 
            });
            
            this.loadingCounter--
        },
        async create()
        {

        },
        async update()
        {

        },
        cancel()
        {

        }
    }
}
</script>
